import React, { useState } from 'react';
import { Card, CardHeader, CardTitle } from 'components/shadcn/ui/card';
import { HGTable } from 'components/HGTable';
import {
    columns,
    CUSTOMERS_LIST_LIMIT,
    CUSTOMERS_PAGE_SIZE,
} from './constants';
import { useSearch } from 'components/HGTable/hooks/useSearch';
import { useSort } from 'components/HGTable/hooks/useSort';
import { usePage } from 'components/HGTable/hooks/usePage';
import { useUsersList } from '../service';

const Customers = () => {
    const pageSize = CUSTOMERS_PAGE_SIZE;
    const limit = CUSTOMERS_LIST_LIMIT;
    const { data: customers, isLoading } = useUsersList('customers', limit);
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState(1);
    const [filterBy, setFilterBy] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState('');

    const filteredCustomers = useSearch(
        customers?.items ?? [],
        search,
        filterBy
    );
    const customersToShow = usePage(filteredCustomers, currentPage, pageSize);
    const sortedData = useSort(customersToShow, sortField, sortDirection);

    return (
        <Card>
            <CardHeader>
                <CardTitle className="text-primary-foreground">
                    Customers
                </CardTitle>
            </CardHeader>
            <HGTable
                title="Customers"
                data={sortedData}
                columns={columns}
                sortDirection={sortDirection}
                setSortDirection={setSortDirection}
                filterBy={filterBy}
                setFilterBy={setFilterBy}
                sortField={sortField}
                setSortField={setSortField}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                loading={isLoading}
                skeletonRows={20}
                search={search}
                setSearch={setSearch}
                canFilter={true}
                canSearch={true}
                pageSize={pageSize}
                totalItems={filteredCustomers?.length}
                onSearchChange={(e) => {
                    setSearch(e);
                }}
            />
        </Card>
    );
};

export default Customers;
